import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTASection from '../../components/feature/FinalCTASection';
import MidPageCTA from '../../components/feature/MidPageCTA';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AIAnswerBlock from './components/AIAnswerBlock';
import WhyChooseUs from './components/WhyChooseUs';

const scrollTo = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Home() {
  return (
    <div className="bg-[#080808] min-h-screen">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <HeroSection onScrollTo={scrollTo} />

        {/* 2. Trust Bar */}
        <TrustBar />

        {/* 3. Services Overview */}
        <ServicesSection onScrollTo={scrollTo} />

        {/* Mid-page CTA #1 — after services */}
        <MidPageCTA
          headline="Your Healing Journey Starts Here"
          sub="Personalized sessions designed around your specific needs, goals, and history."
          cta="Schedule a Consultation"
          image="https://public.readdy.ai/ai/img_res/deb44978275a1a9d9b75ff358fbd40c5.jpg"
        />

        {/* 4. AI Answer Block */}
        <AIAnswerBlock />

        {/* 5. Process */}
        <ProcessSection />

        {/* 6. Why Choose Us */}
        <WhyChooseUs />

        {/* Mid-page CTA #2 — after why choose us */}
        <MidPageCTA
          headline="Experience the Khalsa Healing Difference"
          sub="Serving Yardley, Newtown, Langhorne, and all of Bucks County, PA with elite therapeutic care."
          cta="Book Your Session"
          image="https://readdy.ai/api/search-image?query=Dramatic%20dark%20healing%20room%20with%20shafts%20of%20warm%20golden%20sunlight%20cutting%20through%20linen%20curtains%2C%20a%20practitioner%20silhouetted%20in%20warm%20amber%20light%20preparing%20for%20a%20healing%20session%2C%20the%20atmosphere%20is%20deeply%20intentional%20and%20sacred%2C%20cinematic%20dark%20luxury%20spa%20imagery%2C%20photorealistic%2C%20ultra%20premium%20wellness%20environment&width=1920&height=700&seq=midcta2002&orientation=landscape"
        />

        {/* 7. Service Areas */}
        <ServiceAreasSection />

        {/* 8. Testimonials */}
        <TestimonialsSection onScrollTo={scrollTo} />

        {/* 9. FAQ */}
        <FAQSection />

        {/* 10. Final CTA + 11. Lead Form */}
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
